import React from "react";
import '../../App.css'
import TePaeTawhitiCard from "../TePaeTawhitiCard";
import Roots from "../Roots";

export default function TePaeTawhiti(){
    return (
        <>
            <TePaeTawhitiCard />
            <Roots />
        </>

    )
}